<template>
  <div :class="'e-form-group ' + formStyleClass" ref="formGroup">
    <label v-if="label || $slots.label" :for="name" :class="labelClasses">
      <slot name="label">{{translatedLabel}} {{required ? '*' : ''}}</slot>
      <slot name="label_buttons_panel"></slot>
    </label>
    <slot>
      <e-input v-if="inputType==='input' && !$slots.default"
               :inputStyle="inputStyle"
               :name="name"
               :model="model"
               :required="required"
               :validationRule="validationRule"
               :modalVariableName="modalVariableName"
               :tabView="tabView"
               :placeholder="translatedPlaceholder"
               :disabled="inputDisabled"
               @input="input"
               @change="change"
               @blur="blur"
               :onChangeValidation="onChangeValidation"
               :mask="mask"
               :validationAdditionalRules="validationAdditionalRules"
               :validateAlias="validateAlias"
               :onValidate="onValidate"
               :formValidator="formValidator || form.formValidator"></e-input>
      <e-url v-if="inputType==='url' && !$slots.default"
               :name="name"
               :model="model"
               :required="required"
               :modalVariableName="modalVariableName"
               :tabView="tabView"
               :placeholder="translatedPlaceholder"
               :disabled="inputDisabled"
               @input="input"
               @change="change"
               @blur="blur"
               :onChangeValidation="onChangeValidation"
               :validateAlias="validateAlias"
               :onValidate="onValidate"
               :formValidator="formValidator || form.formValidator"></e-url>
      <e-input v-else-if="inputType==='password' && !$slots.default"
               :name="name"
               :isPassword="true"
               inputType="password"
               :model="model"
               :required="required"
               :validationRule="validationRule"
               :modalVariableName="modalVariableName"
               :tabView="tabView"
               :placeholder="translatedPlaceholder"
               :disabled="inputDisabled"
               @input="input"
               @blur="blur"
               @change="change"
               :validationAdditionalRules="validationAdditionalRules"
               :validateAlias="validateAlias"
               :onChangeValidation="onChangeValidation"
               :formValidator="formValidator || form.formValidator"></e-input>
      <e-calendar v-else-if="inputType==='calendar' && !$slots.default"
                  :name="name"
                  :model="model"
                  :required="required"
                  :validationRule="validationRule"
                  :modalVariableName="modalVariableName"
                  :tabView="tabView"
                  :placeholder="translatedPlaceholder"
                  :disabled="inputDisabled"
                  :format="format"
                  :valueFormat="valueFormat"
                  :type="type"
                  :validateAlias="validateAlias"
                  :formValidator="formValidator || form.formValidator"
      ></e-calendar>
      <e-calendar-range v-else-if="inputType==='calendar-range' && !$slots.default"
                  :name="name"
                  :model="model"
                  :required="required"
                  :validationRule="validationRule"
                  :modalVariableName="modalVariableName"
                  :tabView="tabView"
                  :placeholder="translatedPlaceholder"
                  :disabled="inputDisabled"
                  :format="format"
                  :valueFormat="valueFormat"
                  :type="type"
                  :validateAlias="validateAlias"
                  :formValidator="formValidator || form.formValidator"

                  :toPlaceholder="toPlaceholder"
                  :toName="toName"
      ></e-calendar-range>
      <e-time v-else-if="inputType==='time' && !$slots.default"
                  :name="name"
                  :model="model"
                  :required="required"
                  :validationRule="validationRule"
                  :modalVariableName="modalVariableName"
                  :tabView="tabView"
                  :placeholder="translatedPlaceholder"
                  :disabled="inputDisabled"
                  :format="format"
                  :valueFormat="valueFormat"
                  :type="type"
                  :validateAlias="validateAlias"
                  :formValidator="formValidator || form.formValidator"
      ></e-time>
      <e-select v-else-if="inputType==='select' && !$slots.default"
                :inputStyle="inputStyle"
                :disablePlaceholderOption="disablePlaceholderOption"
                :name="name"
                :model="model"
                :required="required"
                :validationRule="validationRule"
                :modalVariableName="modalVariableName"
                :tabView="tabView"
                :placeholder="translatedPlaceholder"
                :options="options"
                :optionValueKey="optionValueKey"
                :optionTextKey="optionTextKey"
                :disabled="inputDisabled"
                @change="change"
                :onChangeValidation="onChangeValidation"
                :formValidator="formValidator || form.formValidator"></e-select>
      <e-tags
        v-else-if="inputType==='tags' && !$slots.default"
        :disablePlaceholderOption="disablePlaceholderOption"
        :name="name"
        :model="model"
        :required="required"
        :validationRule="validationRule"
        :modalVariableName="modalVariableName"
        :tabView="tabView"
        :placeholder="translatedPlaceholder"
        :options="options"
        :optionValueKey="optionValueKey"
        :optionTextKey="optionTextKey"
        :disabled="inputDisabled"
        @change="change"
        :onChangeValidation="onChangeValidation"
        :tagDelimiters="tagDelimiters"
        :formValidator="formValidator || form.formValidator"
      ></e-tags>
      <e-tags-input
        v-else-if="inputType==='tags-input' && !$slots.default"
        :disablePlaceholderOption="disablePlaceholderOption"
        :name="name"
        :model="model"
        :required="required"
        :validationRule="validationRule"
        :modalVariableName="modalVariableName"
        :tabView="tabView"
        :placeholder="translatedPlaceholder"
        :options="options"
        :optionValueKey="optionValueKey"
        :optionTextKey="optionTextKey"
        :disabled="inputDisabled"
        @change="change"
        :onChangeValidation="onChangeValidation"
        :formValidator="formValidator || form.formValidator"
        :collapseSize="collapseSize"
      ></e-tags-input>
      <e-select-nested-list v-else-if="inputType==='select-nested-list' && !$slots.default"
        :name="name"
        :model="model"
        :required="required"
        :validationRule="validationRule"
        :modalVariableName="modalVariableName"
        :tabView="tabView"
        :placeholder="translatedPlaceholder"
        :options="options"
        :optionValueKey="optionValueKey"
        :optionTextKey="optionTextKey"
        :disabled="inputDisabled"
        :adapter="adapter"
        @change="change"
        :childsKey="childsKey"
        :optionTextFunc="optionTextFunc"
        :onChangeValidation="onChangeValidation"
        :formValidator="formValidator || form.formValidator"
      ></e-select-nested-list>
      <e-textarea v-else-if="inputType==='textarea' && !$slots.default"
                  :name="name"
                  :model="model"
                  :required="required"
                  :validationRule="validationRule"
                  :modalVariableName="modalVariableName"
                  :tabView="tabView"
                  :placeholder="translatedPlaceholder"
                  @change="change"
                  :onChangeValidation="onChangeValidation"
                  :disabled="inputDisabled"
                  :formValidator="formValidator || form.formValidator"
      ></e-textarea>
      <e-suggestion v-else-if="inputType==='suggestion' && !$slots.default"
                    :name="name"
                    :model="model"
                    :required="required"
                    :validationRule="validationRule"
                    :modalVariableName="modalVariableName"
                    :options="options"
                    :valueKey="optionValueKey"
                    :nameKey="optionTextKey"
                    :tabView="tabView"
                    :placeholder="translatedPlaceholder"
                    :realName="realName"
                    :minSuggestLen="minSuggestLen"
                    @change="change"
                    @clear="change"
                    :onChangeValidation="onChangeValidation"
                    :disabled="inputDisabled"
                    :suggestionEndpoint="suggestionEndpoint"
                    :transformSuggestions="transformSuggestions"
                    @selectItem="onSelectItem"
                    :useInnerSearch="useInnerSearch"
                    :maxShowedOptions="maxShowedOptions"
                    :dontShowErrorInFinishComponent="dontShowErrorInFinishComponent"
                    :formValidator="formValidator || form.formValidator"
      ></e-suggestion>
      <e-suggestion-multiselect v-else-if="inputType==='suggestion[]' && !$slots.default"
                    :name="name"
                    :model="model"
                    :required="required"
                    :validationRule="validationRule"
                    :modalVariableName="modalVariableName"
                    :options="options"
                    :valueKey="optionValueKey"
                    :textKey="optionTextKey"
                    :tabView="tabView"
                    :placeholder="translatedPlaceholder"
                    :realName="realName"
                    :minSuggestLen="minSuggestLen"
                    :enableSelectAll="enableSelectAll"
                    @change="change"
                    :onChangeValidation="onChangeValidation"
                    :disabled="inputDisabled"
                    :suggestionEndpoint="suggestionEndpoint"
                    :transformSuggestions="transformSuggestions"
                    @selectItem="onSelectItem"
                    :useInnerSearch="useInnerSearch"
                    :alwaysOpen="alwaysOpen"
                    :selectAllOnCreate="selectAllOnCreate"
                    :useOuterOptionsFilter="useOuterOptionsFilter"
                    :dontShowErrorInFinishComponent="dontShowErrorInFinishComponent"
                    :formValidator="formValidator || form.formValidator"
      ></e-suggestion-multiselect>
      <e-checkbox-multi v-else-if="inputType==='checkbox[]' && !$slots.default"
                        :name="name"
                        :model="model"
                        :required="required"
                        :modalVariableName="modalVariableName"
                        :tabView="tabView"
                        :placeholder="translatedPlaceholder"
                        :options="options"
                        :optionValueKey="optionValueKey"
                        :optionTextKey="optionTextKey"
                        :disabled="inputDisabled"
                        @change="change"
                        :onChangeValidation="onChangeValidation"
                        :formValidator="formValidator || form.formValidator"
      ></e-checkbox-multi>
      <e-checkbox v-else-if="inputType==='checkbox' && !$slots.default"
                        :value="value"
                        :caption="translatedCaption"
                        :name="name"
                        :model="model"
                        :required="required"
                        :modalVariableName="modalVariableName"
                        :tabView="tabView"
                        :placeholder="translatedPlaceholder"
                        :disabled="inputDisabled"
                        @change="change"
                        :onChangeValidation="onChangeValidation"
                        :formValidator="formValidator || form.formValidator"
      ></e-checkbox>
      <e-radio v-else-if="inputType==='radio' && !$slots.default"
                        :name="name"
                        :model="model"
                        :required="required"
                        :modalVariableName="modalVariableName"
                        :tabView="tabView"
                        :placeholder="translatedPlaceholder"
                        :options="options"
                        :optionValueKey="optionValueKey"
                        :optionTextKey="optionTextKey"
                        :disabled="inputDisabled"
                        @change="change"
                        :onChangeValidation="onChangeValidation"
                        :formValidator="formValidator || form.formValidator"
      ></e-radio>
      <e-simple-file-uploader v-else-if="inputType==='simple-file-uploader' && !$slots.default"
                  :name="name"
                  :model="model"
                  :required="required"
                  :validationRule="validationRule"
                  :modalVariableName="modalVariableName"
                  :tabView="tabView"
                  :placeholder="translatedPlaceholder"
                  @change="change"
                  @fileUploaded="(e) => $emit('fileUploaded', e)"
                  @fileRemoved="(e) => $emit('fileRemoved', e)"
                  :onChangeValidation="onChangeValidation"
                  :disabled="inputDisabled"
                  :formValidator="formValidator || form.formValidator"
                  :uploadUrl="uploadUrl"
                  :showFilePreview="showFilePreview"
                  :uploadType="uploadType"
      ></e-simple-file-uploader>
      <e-address
        v-else-if="inputType==='address'"
        :inputStyle="inputStyle"
        :name="name"
        :model="model"
        :required="required"
        :validationRule="validationRule"
        :modalVariableName="modalVariableName"
        :tabView="tabView"
        :placeholder="translatedPlaceholder"
        :options="options"
        :optionValueKey="optionValueKey"
        :optionTextKey="optionTextKey"
        :disabled="inputDisabled"
        @selectItem="onSelectItem"
        @change="change"
        :onChangeValidation="onChangeValidation"
        :formValidator="formValidator || form.formValidator"
        :addressIdFieldName="addressIdFieldName"
        :addressData="addressData"
        :houseFiasFieldName="houseFiasFieldName"
        :fiasFieldName="fiasFieldName"
        :validateAlias="validateAlias"
        :geoFields="geoFields"
        :callbacks="callbacks"
        :onValidate="onValidate"
        :treeAttributes="treeAttributes"
        :addressProvider="addressProvider"
      >
        <template v-slot:buttons_panel>
          <slot name="buttons_panel"></slot>
        </template>
      </e-address>
      <data-autocomplete
          v-else-if="inputType==='inn' || inputType==='ogrn' || inputType==='name'"
          :name="name"
          :model="model"
      >
      </data-autocomplete>

    </slot>
    <transition name="fade">
      <span class="invalid error" v-show="error">{{error}}</span>
    </transition>
    <transition name="fade">
      <span class="form-group-tip" v-if="tip">{{translatedTip}}</span>
    </transition>
    <slot name="footer"></slot>
  </div>
</template>

<script>
  import {FORCE_ENABLE_DISABLED_FIELDS} from '../../config/config.js'
  import permissionMixin from '../../mixins/permission-mixin.js'

  export default {
    data () {
      return {
        error: null
      }
    },
    mixins: [permissionMixin],
    name: 'e-form-group',
    props: {
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      onChangeValidationOptions: {
        type: Object,
        default: function () {
          return {
            disableAutoFocus: false
          }
        }
      },
      /* Стиль формы */
      formGroupStyle: {
        type: String,
        default: 'col-block'
      },
      inputStyle: {
        type: Object,
        default: () => {}
      },
      formValidator: null,
      /* имя поля */
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      /* имя поля для suggestion, откуда берется id и т.п. */
      realName: {
        type: String,
        default: null
      },
      /* имя таба где находится форма(например tab1) */
      tabView: {
        type: String,
        default: null,
        required: true
      },
      /* модель, вроде везде называется fields */
      model: {
        type: Object
      },
      /* название */
      label: {
        type: String,
        default: null
      },
      /* знач value у чекбоска */
      value: {
        type: [Boolean, Number],
        default: true
      },
      /* название отображ справа от чекбокса */
      caption: {
        type: String,
        default: null
      },
      /* обязательное или нет */
      required: {
        type: Boolean,
        default: false
      },
      /* тип: (input|select|calendar) */
      inputType: {
        type: String,
        default: 'input'
      },
      /* правило валидации */
      validationRule: {
        type: String,
        default: 'string'
      },
      /* имя переменной, по которой открываетмя маленькая модалка */
      modalVariableName: {
        type: String,
        default: null
      },
      /* активен или нет */
      disabled: {
        type: Boolean,
        default: false
      },
      /* placeholder */
      placeholder: {
        type: String,
        default: undefined
      },
      /* для select'a */
      /* опции для select'a */
      options: null,
      optionValueKey: {
        type: String,
        default: 'id'
      },
      optionTextKey: {
        type: String,
        default: 'name'
      },
      maxShowedOptions: {
        type: Number
      },
      adapter: {
        type: Function,
        default: (tree) => tree
      },
      childsKey: {
        type: String,
        default: 'childs'
      },
      mask: {
        type: String,
        default: null
      },
      /* Calnedar */
      format: null,
      valueFormat: null,
      /* Multiselect */
      enableSelectAll: {
        type: Boolean,
        default: false
      },
      alwaysOpen: {
        type: Boolean,
        default: false
      },
      useOuterOptionsFilter: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: undefined
      },
      // suggestion
      suggestionEndpoint: {
        type: Function,
        // eslint-disable-next-line
        default: function (ctx, value) {
          return null
        }
      },
      transformSuggestions: {
        type: Function,
        default: function (ctx, data) {
          return data
        }
      },
      useInnerSearch: {
        type: Boolean,
        default: true
      },
      minSuggestLen: {
        type: Number,
        default: 0
      },
      selectAllOnCreate: {
        type: Boolean,
        default: false
      },
      uploadUrl: {
        type: Function,
        default: function () {
          return null
        }
      },
      validationAdditionalRules: {
        type: Object,
        default: function () {
          return {}
        }
      },
      showFilePreview: {
        type: Boolean,
        default: false
      },
      tip: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      optionTextFunc: {
        type: Function
      },
      addressIdFieldName: {
        type: String
      },
      addressData: {
        type: Object
      },
      houseFiasFieldName: {
        type: String
      },
      fiasFieldName: {
        type: String
      },
      geoFields: {
        type: Array
      },
      dontShowErrorInFinishComponent: {
        type: Boolean
      },
      callbacks: {
        type: Object
      },
      uploadType: {
        type: String
      },
      // e-calendar-range options
      toName: {
        type: String
      },
      toPlaceholder: {
        type: String
      },
      // e-tags options
      collapseSize: {
        type: Number
      },
      tagDelimiters: {
        type: Array
      },
      addressProvider: {
        type: String
      },
      treeAttributes: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      isFormDisabled () {
        let name = this.$sharedServices.router.history.current.name
        return this.$sharedServices.store.getters.formState(name, 'disabledForms')
      },
      formStyleClass () {
        return `${this.formGroupStyle} ${this.invalidGroupClass} ${this.inputDisabled ? 'disabled' : ''}`
      },
      inputDisabled () {
        if (FORCE_ENABLE_DISABLED_FIELDS === true) {
          return false
        }
        if (this.isFormDisabled === true || this.userCanWrite === false) {
          return true
        }
        return this.disabled
      },
      form () {
        let parent = this
        let parentName = parent.$options.name
        while (parent) {
          parent = parent.$parent
          parentName = parent.$options.name
          if (parentName === 'e-form' || parentName === 'e-form-search-filter') {
            break
          }
        }
        return parent
      },
      invalidGroupClass () {
        if (!this.error) {
          return ''
        }
        return ' is-invalid '
      },
      labelClasses () {
        let cl = []
        if (this.getError) {
          cl.push(' is-invalid ')
        }
        return cl
      },
      getError () {
        if (!this.error) {
          return false
        }
        return this.error
      },
      translatedPlaceholder () {
        if (this.placeholder) {
          return this.$translate(this.placeholder)
        }
        return this.placeholder
      },
      translatedTip () {
        if (this.tip) {
          return this.$translate(this.tip)
        }
        return this.tip
      },
      translatedCaption () {
        if (this.caption) {
          return this.$translate(this.caption)
        }
        return this.caption
      },
      translatedLabel () {
        if (this.label) {
          return this.$translate(this.label)
        }
        return this.label
      }
    },
    methods: {
      input ($event) {
        this.$emit('input', $event)
      },
      getValidator () {
        return this.formValidator || this.form.formValidator
      },
      onSelectItem ($event) {
        this.$emit('selectItem', $event)
      },
      blur ($event) {
        this.$emit('blur', $event)
        if (this.onChangeValidation) {
          this.validateOnChange()
        }
      },
      change ($event) {
        this.$emit('change', $event)
        if (this.onChangeValidation) {
          this.validateOnChange()
        }
      },
      validateOnChange () {
        this.getValidator().validate(
          null,
          Object.assign(
            {},
            this.onChangeValidationOptions,
            {validateOnly: (this.validateAlias || this.name)
            }
          )
        )
      },
      /* use in slots default */
      getElement () {
        return this.$refs.formGroup
      },
      validate () {
        let msg = ''
        if (this.required) {
          if (!this.model[this.name] || this.model[this.name].length < 1) {
            msg += 'Заполните поле'
          }
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
      /* end */
    },
    created () {
      this.getValidator().subscribeFormGroup(this)
      if (this.$slots.default) {
        this.getValidator().subscribeInput(this)
      }
    },
    destroyed () {
      this.getValidator().unsubscribeFormGroup(this)
      if (this.$slots.default) {
        this.getValidator().unsubscribeInput(this)
      }
    }
  }
</script>
